import { type SocialProvider, SocialSignInButton } from "./SocialSignInButton";

interface AuthSocialButtonsProps {
  disabled?: boolean;
  buttonText?: Partial<Record<SocialProvider, string>>;
}

export function AuthSocialButtons({ disabled = false, buttonText }: AuthSocialButtonsProps) {
  return (
    <div className="flex flex-col gap-3">
      <SocialSignInButton provider="google" text={buttonText?.google} disabled={disabled} />
      <SocialSignInButton provider="facebook" text={buttonText?.facebook} disabled={disabled} />
    </div>
  );
}
